var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMpIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 25,
    viewBox: "0 0 30 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1081_10354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.76953 8.94243L14.9359 3.6805L24.0996 8.94243V14.7866V19.458L14.9359 24.709L5.76953 19.458V14.7866V8.94243Z",
    fill: "#FFCF64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 3.69972L5.76977 8.94242L0.391113 5.95169L9.62115 0.708984L14.9998 3.69972Z",
    fill: "#FFAC27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 3.69972L24.23 8.94242L29.6087 5.95169L20.3787 0.708984L15 3.69972Z",
    fill: "#FFAC27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.634766 11.6475L9.62409 16.9342L14.9363 14.1934L5.90828 8.94241L0.634766 11.6475Z",
    fill: "#FFAC27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2376 11.6475L20.2483 16.9342L14.936 14.1934L23.9641 8.94241L29.2376 11.6475Z",
    fill: "#FFAC27"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1081_10354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.2174,
    height: 24,
    fill: "white",
    transform: "translate(0.391113 0.708984)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMpIcon1);
export default __webpack_public_path__ + "static/media/mpIcon1.295b90b697cff8cd8ef99c00b8264e07.svg";
export { ForwardRef as ReactComponent };